if(!customElements.get('product-gallery')) {
  /**
   *  @class
   *  @function ProductGallery
   */
  class ProductGallery extends HTMLElement {
    constructor() {
      super();
           
      this.setupProductGallery()
      this.setupDrag()
    }
    connectedCallback() {
      if(document.querySelector('variant-selects')) {
        this.updateVariantOptions();
        this.updateVariantMasterId();
      }
    }
    setupProductGallery() {
      this.thumbnailsElement = this.querySelector('.product-images__thumbnails');
      this.thumbnailList = this.querySelectorAll('.product-images__thumbnail');
      this.mediaList = this.querySelectorAll('.product-images .product-images__slide');
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.currentPage = +this.thumbnailsElement.querySelector('.is-active').getAttribute('data-media-pos');
      this.prevButton =  this.querySelector('.product-images__previous');
      this.nextButton =  this.querySelector('.product-images__next');
      this.productSlider = this.parentElement.parentElement;
      this.currentAction = 'variant'
      this.onScrollToActiveThumbnail(this.thumbnailsElement.querySelector('.is-active'))

      if(this.classList.contains('product-images--gallery__wrapper--bottom')) {
        this.thumbnailsElement.addEventListener('wheel', (e) => {
          e.preventDefault();
          this.thumbnailsElement.scrollLeft += e.deltaY / 4;
        })
      }

      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

      this.thumbnailList.forEach((thumb) => {
        thumb.addEventListener('click', this.onThumbnailClick.bind(this))
      })

      if(document.querySelector('variant-selects')){
        this.variantSelects = document.querySelector('variant-selects');
        this.variantDataset = this.variantSelects.dataset;
        
        this.variantSelects.addEventListener('change', () => {
          this.currentAction = 'variant'
          this.updateMedia()
        });
      }
      
      this.updateButtons()
      
    }
    updateVariantOptions() {
      this.fieldsets = Array.from(this.variantSelects.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
    }
    updateVariantMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
    updateMedia() {

      let mediaId = '';
      this.thumbnailList.forEach((thumb) => {
        if(thumb.getAttribute('data-media-pos') == this.currentPage)
          mediaId = thumb.getAttribute('data-media-id')
      })

      if(document.querySelector('variant-selects')) {
        this.updateVariantOptions();
        this.updateVariantMasterId();

        if (!this.currentVariant) return;
        // if (!this.currentVariant.featured_media) return;
        if (!this.productSlider) return;
        

        if(this.currentAction == 'variant' && this.currentVariant.featured_media !== null) {
          mediaId = `${this.variantDataset.section}-${this.currentVariant.featured_media.id}`;
        }
      }
      
      
        
      let activeMedia = this.productSlider.querySelectorAll(`[data-media-id="${mediaId}"]`);

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      activeMedia.forEach((active) => {
        active.classList.add('is-active')
        if(active.classList.contains('product-images__thumbnail')) {
          this.currentPage = +active.getAttribute('data-media-pos');
          this.onScrollToActiveThumbnail(active)
        }
      })

      
      this.updateButtons();

    }
    updateButtons() {
      this.nextButton.classList.remove('is-hidden');
      this.prevButton.classList.remove('is-hidden');

      if(this.currentPage <= 1) 
        this.prevButton.classList.add('is-hidden');

      if(this.currentPage >= this.mediaList.length) 
        this.nextButton.classList.add('is-hidden');

      if(this.mediaList.length >= 2) {
        if (this.currentPageElement) this.currentPageElement.textContent = this.currentPage;
        let progressBarFill = this.querySelector('.slider-progress-bar-fill');
        if (progressBarFill) {
          progressBarFill.style.width = `calc((${this.currentPage} / ${this.mediaList.length}) * 100%)`;
        }
      }
    }
    onButtonClick({target}) {
      if(target.getAttribute('attr-value') === 'prev') {
        if(this.currentPage <= 1) return;
        
        this.currentPage -= 1;
      }

      if(target.getAttribute('attr-value') === 'next') {
        if(this.currentPage >= this.mediaList.length) return;
        
        this.currentPage += 1;
      }
      this.currentAction = 'button';
      this.updateMedia()
    }
    onThumbnailClick({target}) {
      this.currentPage = +target.getAttribute('data-media-pos');
      this.currentAction = 'thumbnail';
      this.updateMedia()
    }
    onScrollToActiveThumbnail(active) {
      
      if((active.offsetLeft + active.clientWidth - this.thumbnailsElement.scrollLeft) > this.thumbnailsElement.clientWidth) {
        // Out of frame on the right
        this.thumbnailsElement.scrollTo({
          left: active.offsetLeft - (this.thumbnailsElement.clientWidth - active.clientWidth - (active.clientWidth / 2.5)),
          behavior: 'smooth'
        })
      }
      
      if((active.offsetLeft - this.thumbnailsElement.scrollLeft) < 0) {
        // Out of frame on the left
        this.thumbnailsElement.scrollTo({
          left: active.offsetLeft - (active.clientWidth / 2.5),
          behavior: 'smooth'
        })
      }

      if((active.offsetTop + active.clientHeight - this.thumbnailsElement.scrollTop) > this.thumbnailsElement.clientHeight) {
        // Out of frame on the bottom
        this.thumbnailsElement.scrollTo({
          top: active.offsetTop - (this.thumbnailsElement.clientHeight - active.clientHeight - (active.clientHeight / 2.5)),
          behavior: 'smooth'
        })
      }
      
      if((active.offsetTop - this.thumbnailsElement.scrollTop) < 0) {
        // Out of frame on the top
        this.thumbnailsElement.scrollTo({
          top: active.offsetTop - (active.clientHeight / 2.5),
          behavior: 'smooth'
        })
      }
    }
    setupDrag() {
      this.galleryWrapper = document.querySelector('.product-images--gallery');
      this.galleryWrapper.addEventListener('touchstart', handleTouchStart.bind(this), false);        
      this.galleryWrapper.addEventListener('touchmove', handleTouchMove.bind(this), false);

      let xDown = null;                                                        
      let yDown = null;

      function getTouches(evt) {
        return evt.touches || evt.originalEvent.touches;
      }                                                     
                                                                              
      function handleTouchStart(evt) {
        const firstTouch = getTouches(evt)[0];                                      
        xDown = firstTouch.clientX;                                      
        yDown = firstTouch.clientY;                                      
      };                                                
                                                                              
      function handleTouchMove(evt) {
        if ( ! xDown || ! yDown ) return;

        let xUp = evt.touches[0].clientX;                                    
        let yUp = evt.touches[0].clientY;

        let xDiff = xDown - xUp;
        let yDiff = yDown - yUp;
                                                                            
        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
          if ( xDiff > 0 ) {
            /* left swipe */ 
            this.onButtonClick({target: this.nextButton})
          } else {
            /* right swipe */
            this.onButtonClick({target: this.prevButton})
          }                       
        }

        xDown = null;
        yDown = null;                                             
      };
      
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.variantSelects.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define('product-gallery', ProductGallery);
}